import {Breadcrumb, Card, Tabs} from "antd";
import {Link} from "react-router-dom";
import FileStoreConfigCard from "../components/fileStoreConfig";
import {useEffect, useState} from "react";
import {get} from "../core/request";
import Loading from "../components/loading";

export default function FilterSettingsView(props: any) {

    const [tabs, setTabs] = useState([{
        key: "loading",
        label: "Laden...",
        children: <Card children={<Loading/>}/>
    }] as any[]);

    useEffect(() => {
        get(
            "stores"
        ).done((response) => {
                console.debug("response.data.data", response.data.data);
                setTabs(
                    response.data.data.map((entry: any) => (
                            {
                                key: entry['key'],
                                label: entry['title'],
                                children: <FileStoreConfigCard path={`stores/${entry.key}`} rows={20}/>
                            }
                        )
                    )
                );
            }
        ).fail(
            () => setTabs([{
                key: "failed",
                label: "Fehler beim Laden der verfügbaren Stores",
                children: <FileStoreConfigCard path={`stores/failed`} rows={20}/>
            }])
        )
    }, []);

    useEffect(() => {
        console.log(tabs)
    }, [tabs]);

    const breadcrumb = (
        <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Filter Einstellungen</Breadcrumb.Item>
        </Breadcrumb>
    )

    return (
        <>
            {breadcrumb}
            <Tabs defaultActiveKey="1" items={tabs}/>
        </>
    )
}
